import { OrganisationAssignmentDto, OrganisationScoredCompaniesDto } from 'models/dtoTypes';
import { getKosmosCompanyApi } from 'services';

export const GetSgAssignmentByKosmosCompany = async (
  kosmosCompanyId: string,
): Promise<OrganisationAssignmentDto> => {
  const client = await getKosmosCompanyApi();
  const response = await client.getSgAssignmentByKosmosCompany(kosmosCompanyId);
  return response.data;
};

export const GetOrganisationScoredCompany = async (
  kosmosCompanyId: string,
  organisationId: string,
): Promise<OrganisationScoredCompaniesDto> => {
  const client = await getKosmosCompanyApi();
  const response = await client.getOrganisationScoredCompany(kosmosCompanyId, organisationId);
  return response.data;
};
